export default interface IWorldComponent {
    id: string;
    type: WorldComponentType;
    x: number;
    y: number;
    [key: string]: any;
}

export enum WorldComponentType {
    FIELD = 'field',
    SUITCASE = 'suitcase',
}
